import TaskNameDataAccuracy from "../../../../components/AssetManagement/Health/DataAccuracy/TaskNameDataAccuracy/TaskNameDataAccuracy";
import { useEffect } from "react";
import {
  selectUserData,
  selectUserToken,
} from "../../../../features/userSlice";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import DataAccuracyFullSkeleton from "./DataAccuracyFullSkeleton";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../../components/Page404/Page403";
import FloatingActionItems from "../../../FloatingItems/FloatingActionItems";
import { fetchDataAccuracy } from "../../../../components/AssetManagement/Health/DataAccuracy/DataAccuracyHelpers/helpers";
import { DataAccuracyEndPointLogic } from "../../../../logic/AssetManagement/Health/Data Accuracy/dataAccuracyEndPointLogic";
const TaskNameDataAccruracyScreen = () => {
  const token = useSelector(selectUserToken);
  const [searchParams] = useSearchParams();
  const taskStructureSharedUid = searchParams.get("task_structure_shared_uid");
  const assetSharedUid = searchParams.get("asset_shared_uids")?.split(",");
  const bizLayerQueryId = searchParams.get("query_id");
  const response = useSelector(selectUserData);
  const dispatch = useDispatch();
  const { tasksByTaskStructureSharedUidLoader, isSuccess } = useSelector(
    (state: any) => state.dataAccuracy,
  );
  const queryId = "5637377896742912";
  const fetchBy = searchParams.get("fetchBy") || "Website";
  const type = fetchBy === "Website" ? "site" : "dimension";
  const selectedSites = searchParams.get("selected")?.split(",");
  const siteAndDimensionsList = useSelector(selectUserData);
  const dimensionList = siteAndDimensionsList?.data?.dimensions;
  const siteList = siteAndDimensionsList?.data?.website_permissions;
  const { allDimensions } = useSelector((state: any) => state.dataAccuracy);
  const userPermittedOrganizationName =
    siteAndDimensionsList?.data?.user_details?.organization_name;
  const allDimenssionList = allDimensions.filter(
    (dimension: any) =>
      dimension.organization_id__organization_name ===
      userPermittedOrganizationName,
  );

  const filteredDimensionList = allDimenssionList.map((dimension: any) => {
    return dimension.dimension;
  });

  const initialSelected = searchParams.get("selected")?.split(",") || [];

  const hasEditDataAnomalyPermission = CheckPermissions(
    response?.data?.products?.assets,
    "health",
    "edit_data_anomaly",
  );

  const handleFetch = async () => {
    await fetchDataAccuracy({
      token,
      queryId,
      type,
      fetchBy,
      selectedSites,
      filteredDimensionList,
      dimensionList,
      siteList,
      taskStructureSharedUid,
      assetSharedUid,
      dispatch,
    });
  };

  useEffect(() => {
    if (hasEditDataAnomalyPermission) {
      handleFetch();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (hasEditDataAnomalyPermission && isSuccess) {
      handleFetch();
    }
    // eslint-disable-next-line
  }, [isSuccess]);

  useEffect(() => {
    if (bizLayerQueryId !== null) {
      DataAccuracyEndPointLogic.getBizLayerQuery(
        token,
        bizLayerQueryId,
        dispatch,
      );
    }
    // eslint-disable-next-line
  }, [bizLayerQueryId]);

  return (
    <>
      {!hasEditDataAnomalyPermission ? (
        <Page404 />
      ) : tasksByTaskStructureSharedUidLoader ? (
        <DataAccuracyFullSkeleton />
      ) : (
        <>
          <TaskNameDataAccuracy />
          {initialSelected?.length > 0 ? (
            <div data-tracker="514">
              <FloatingActionItems
                selectedSiteFloatingAction={initialSelected[0]}
                selectedDimensionsFloatingAction={""}
                trackIdFloatingAction={"515"}
              />
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default TaskNameDataAccruracyScreen;
